import { Avatar, useTheme } from '@mui/material';
import React, { Fragment } from 'react';
import { ReactComponent as EditEmployeeAvatar } from '../../../../../assets/icons/EditEmployeeAvatar.svg';
import { ReactComponent as VendorTruckIcon } from '../../../../../assets/icons/VendorTruckIcon.svg';
import { ReactComponent as WeeklyContractIcon } from '../../../../../assets/icons/WeeklyContractIcon.svg';
import { generateCardFunction } from '../helpers';
import {
  ContractCardDetailsContainer,
  ContractCardDetailsText,
  ContractCardFunction,
  ContractCardName,
} from './styles';
import { ContractCardDetailsProps } from '../types';

const ContractCardDetails: React.FC<ContractCardDetailsProps> = ({ card }) => {
  const theme = useTheme();
  const { isWeekly, isSlot } = card;

  const getCardAvatar = () => {
    if (isSlot) {
      return (
        <Avatar sx={{ width: '32px', height: '32px', backgroundColor: theme.palette.primary.main }}>
          <VendorTruckIcon />
        </Avatar>
      );
    }
    if (card.profilePicture) {
      return <Avatar sx={{ width: '32px', height: '32px' }} src={card.profilePicture} />;
    }
    return (
      <Avatar sx={{ width: '32px', height: '32px' }}>
        <EditEmployeeAvatar />
      </Avatar>
    );
  };

  return (
    <Fragment key={card.contractDateId}>
      <ContractCardDetailsContainer>
        {getCardAvatar()}
        <ContractCardDetailsText>
          <ContractCardName active={card.isEditable}>{card.fullName}</ContractCardName>
          <ContractCardFunction>{generateCardFunction(card.function)}</ContractCardFunction>
        </ContractCardDetailsText>
        {isWeekly && <WeeklyContractIcon fill={theme.palette.secondary.main} />}
      </ContractCardDetailsContainer>
    </Fragment>
  );
};

export default ContractCardDetails;
